import { isEmpty } from './generic';

export const isDisabled = (
  text: string = '',
  hasLanguage: boolean = true,
  isLoading: boolean = false,
): boolean => {
  return isEmpty(text) || !hasLanguage || isLoading;
};

export const tooltipContent = (
  text: string,
  hasLanguage: boolean,
  isLoading: boolean,
): string => {
  if (!hasLanguage) {
    return "Can't find the conversation's language";
  }
  if (isEmpty(text)) {
    return 'No text to translate';
  }
  if (isLoading) {
    return 'Translating...';
  }
  return `Translate to conversation's language`;
};

export const quickTranslateUtils = {
  getStatus(options: {
    text: string;
    hasLanguage: boolean;
    isLoading?: boolean;
  }): { isDisabled: boolean; tooltipContent: string } {
    return {
      isDisabled: isDisabled(
        options.text,
        options.hasLanguage,
        !!options.isLoading,
      ),
      tooltipContent: tooltipContent(
        options.text,
        options.hasLanguage,
        !!options.isLoading,
      ),
    };
  },
};
